/* ============================================================================
   Joe's Kitchen — Dark "Crave" Meal Prep interactions
   - Countdown to the weekly order cutoff (client clock)
   - "This week" carousel prev/next
   - Plan picker (box size = target meal count) → meal builder
   - Builder adds the REAL selected plate variants to the live Shopify cart at
     their real prices (window.JK.addBulk), then resets. No fake plan pricing.
   ============================================================================ */
(function () {
  const money = (cents) => (window.JK && window.JK.money ? window.JK.money(cents) : '$' + (cents / 100).toFixed(2));
  const I = (n) => (window.JK && window.JK.icon ? window.JK.icon(n) : '');

  /* ---------------------------------------------------- COUNTDOWN ---------- */
  (function () {
    const root = document.getElementById('mpCountdown');
    if (!root) return;
    const dEl = document.getElementById('cdD'), hEl = document.getElementById('cdH'),
          mEl = document.getElementById('cdM'), sEl = document.getElementById('cdS'),
          delEl = document.getElementById('cdDeliver');
    const cutoffDay = parseInt(root.dataset.cutoffDay, 10);       // 0=Sun … 6=Sat
    const deliverOffset = parseInt(root.dataset.deliverOffset, 10);
    const CUT = isNaN(cutoffDay) ? 4 : cutoffDay;                 // default Thursday
    const OFF = isNaN(deliverOffset) ? 3 : deliverOffset;        // default +3 → Sunday
    const pad = (n) => String(n).padStart(2, '0');
    const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    function tick() {
      const now = new Date();
      const cutoff = new Date(now);
      cutoff.setDate(now.getDate() + ((CUT - now.getDay() + 7) % 7));
      cutoff.setHours(23, 59, 59, 999);
      if (cutoff.getTime() < now.getTime()) cutoff.setDate(cutoff.getDate() + 7);
      const deliver = new Date(cutoff);
      deliver.setDate(cutoff.getDate() + OFF);
      let diff = Math.max(0, cutoff.getTime() - now.getTime());
      const dd = Math.floor(diff / 864e5); diff -= dd * 864e5;
      const hh = Math.floor(diff / 36e5); diff -= hh * 36e5;
      const mm = Math.floor(diff / 6e4); diff -= mm * 6e4;
      const ss = Math.floor(diff / 1e3);
      if (dEl) dEl.textContent = pad(dd);
      if (hEl) hEl.textContent = pad(hh);
      if (mEl) mEl.textContent = pad(mm);
      if (sEl) sEl.textContent = pad(ss);
      if (delEl) delEl.innerHTML = `Delivered <strong>${DOW[deliver.getDay()]}, ${MON[deliver.getMonth()]} ${deliver.getDate()}</strong>`;
    }
    tick();
    setInterval(tick, 1000);
    const onScroll = () => root.classList.toggle('compact', window.scrollY > window.innerHeight * 0.6);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* ---------------------------------------------------- CAROUSEL ----------- */
  (function () {
    const scroller = document.getElementById('twScroller');
    if (!scroller) return;
    requestAnimationFrame(() => { scroller.scrollLeft = 44; });
    const step = () => 320;
    const prev = document.getElementById('twPrev');
    const next = document.getElementById('twNext');
    if (prev) prev.addEventListener('click', () => scroller.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => scroller.scrollBy({ left: step(), behavior: 'smooth' }));
  })();

  /* ---------------------------------------------------- BUILDER ------------ */
  const dishesWrap = document.getElementById('dishes');
  if (!dishesWrap) return;

  const cards = Array.from(dishesWrap.querySelectorAll('.mp-dish'));
  const qty = {};
  cards.forEach((c) => { qty[c.dataset.id] = 0; });
  const meta = {};
  cards.forEach((c) => {
    meta[c.dataset.id] = {
      variantId: parseInt(c.dataset.variantId, 10),
      price: parseInt(c.dataset.price, 10) || 0,
      name: c.dataset.name || '',
    };
  });

  let planSize = 0;
  // meal-prep discount tiers (real Shopify codes applied at checkout)
  const DISCOUNT = { 10: 0.10, 15: 0.15 };
  const count = () => Object.values(qty).reduce((a, b) => a + b, 0);
  const subtotal = () => cards.reduce((s, c) => s + qty[c.dataset.id] * meta[c.dataset.id].price, 0);

  const prog = document.getElementById('mpProgress');
  const mppCount = document.getElementById('mppCount');
  const mppSub = document.getElementById('mppSub');
  const mppFill = document.getElementById('mppFill');
  const mppBtn = document.getElementById('mppBtn');

  function update() {
    const c = count();
    const full = planSize > 0 && c >= planSize;
    document.body.classList.toggle('mp-full', full);

    if (planSize > 0 && c > 0) { prog.classList.add('up'); document.body.classList.add('mp-bar-active'); }
    else { prog.classList.remove('up'); document.body.classList.remove('mp-bar-active'); }
    prog.classList.toggle('full', full);

    const pct = planSize ? Math.min(100, (c / planSize) * 100) : 0;
    mppFill.style.width = pct + '%';
    mppCount.innerHTML = `<b>${c}</b> / ${planSize || '–'} meals`;
    const left = planSize - c;
    const dpct = DISCOUNT[planSize] || 0;
    const sub = subtotal();
    mppSub.innerHTML = full
      ? (dpct
          ? `Your week is ready — <span class="amt">${money(Math.round(sub * (1 - dpct)))}</span> after ${Math.round(dpct * 100)}% off`
          : `Your week is ready — <span class="amt">${money(sub)}</span>`)
      : (planSize
          ? `${left} more ${left === 1 ? 'meal' : 'meals'} · <span class="amt">${money(sub)}</span> so far${dpct ? ` · ${Math.round(dpct * 100)}% off at ${planSize}` : ''}`
          : 'Pick a plan to start building');
    mppBtn.textContent = full ? (dpct ? `Add to cart · save ${Math.round(dpct * 100)}%` : 'Add to cart') : 'Keep building';

    cards.forEach((card) => {
      const id = card.dataset.id, q = qty[id];
      card.classList.toggle('has', q > 0);
      const tile = card.querySelector('.mp-qtytile');
      tile.textContent = q;
      tile.hidden = q === 0;
      card.querySelector('.mp-step .q').textContent = q;
      card.querySelector('[data-act="dec"]').classList.toggle('disabled', q === 0);
      card.querySelector('[data-act="inc"]').classList.toggle('disabled', full);
      card.querySelector('[data-act="add"]').classList.toggle('disabled', full && q === 0);
    });
  }

  // plan selection (non-destructive: switching size keeps meals already added)
  const planEls = Array.from(document.querySelectorAll('.plan'));
  function setPlan(p, doScroll) {
    if (!p) return;
    planEls.forEach((x) => x.classList.toggle('selected', x === p));
    planSize = parseInt(p.dataset.size, 10) || 0;
    const bw = document.getElementById('buildWrap');
    if (bw) bw.classList.add('active');
    const sub = document.getElementById('buildSub');
    if (sub) sub.textContent = `Add ${planSize} meals to your box — mix and match as you like.`;
    update();
    if (doScroll) {
      const build = document.getElementById('build');
      if (build) window.scrollTo({ top: build.offsetTop - 90, behavior: 'smooth' });
    }
  }
  planEls.forEach((p) => p.addEventListener('click', () => setPlan(p, true)));
  // if the shopper starts adding meals before picking a size, default to the first plan
  function ensurePlan() { if (!planSize) setPlan(planEls[0], false); }

  // card interactions
  cards.forEach((card) => {
    const id = card.dataset.id;
    card.querySelector('[data-act="add"]').addEventListener('click', () => { ensurePlan(); if (planSize && count() < planSize) { qty[id] = 1; update(); } });
    card.querySelector('[data-act="inc"]').addEventListener('click', () => { ensurePlan(); if (planSize && count() < planSize) { qty[id]++; update(); } });
    card.querySelector('[data-act="dec"]').addEventListener('click', () => { if (qty[id] > 0) { qty[id]--; update(); } });
  });

  // add the completed box to the real Shopify cart (only when full).
  // Mirrors the store's existing logic: add the real plate variants stamped
  // with meal-prep line-item properties, enforce one plan per cart, then apply
  // the matching discount code (MEAL10 / MEAL15, or MEAL_RESET for 5) and land
  // on the cart so the saving is shown.
  function addPlan() {
    if (!(planSize && count() >= planSize)) return;
    const planLabel = planSize + ' Meals';
    const planId = 'mealprep_' + Date.now();
    const items = cards
      .filter((c) => qty[c.dataset.id] > 0)
      .map((c) => ({
        id: meta[c.dataset.id].variantId,
        quantity: qty[c.dataset.id],
        properties: { _meal_prep: 'true', _plan_id: planId, _plan_size: planLabel, _locked: 'true' },
      }));
    if (!items.length) return;

    let discountCode = null;
    if (planSize === 10) discountCode = 'MEAL10';
    if (planSize === 15) discountCode = 'MEAL15';

    mppBtn.disabled = true;
    const prevLabel = mppBtn.textContent;
    mppBtn.textContent = 'Adding…';

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        // one meal-prep plan per cart — replace any existing one
        const keys = [];
        (cart.items || []).forEach((li) => {
          const p = li.properties || {};
          let isMP = false;
          if (Array.isArray(p)) { p.forEach((kv) => { if (kv && kv[0] === '_meal_prep' && kv[1] === 'true') isMP = true; }); }
          else if (p._meal_prep === 'true') { isMP = true; }
          if (isMP) keys.push(li.key);
        });
        if (keys.length) {
          const ok = confirm('You already have a meal prep plan in your cart. Only one can be added at a time.\n\nReplace it with this new ' + planLabel + ' plan?');
          if (!ok) { mppBtn.disabled = false; mppBtn.textContent = prevLabel; return Promise.reject({ silent: true }); }
          const updates = {};
          keys.forEach((k) => { updates[k] = 0; });
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
        }
        return null;
      })
      .then(() => fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) }))
      .then((res) => {
        if (!res.ok) return res.json().then((e) => { throw new Error((e && e.description) || 'Unable to add meal plan to cart.'); });
        // apply (or reset) the meal-prep discount, then land on the cart
        const code = discountCode || 'MEAL_RESET';
        window.location.href = '/discount/' + code + '?redirect=%2Fcart';
        return null;
      })
      .catch((err) => {
        if (err && err.silent) return;
        console.error(err);
        alert((err && err.message) || 'There was an issue adding your meal plan. Please try again.');
        mppBtn.disabled = false;
        mppBtn.textContent = prevLabel;
      });
  }
  mppBtn.addEventListener('click', addPlan);

  update();
})();
